export const generateChatHandle = (username?: string) => {
  return `${username}@cams`.toLowerCase();
};
